export { registerComponent as registerDividerComponent } from '../../components/builtin/Divider/register'
export { default as Divider } from '../../components/builtin/Divider/Divider'
